import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Company } from 'src/app/lem/models/companies/company';

@Component({
  selector: 'app-societa-list',
  templateUrl: './societa-list.component.html',
  styleUrls: ['./societa-list.component.css']
})
export class SocietaListComponent implements OnInit {

  constructor() { }

  @Input() companyList : Company[];
  @Output() editCompany = new EventEmitter<Company>();
  @Output() deleteCompany = new EventEmitter<Company>();

  ngOnInit() {

  }

  onEditCompany(company : Company) {
    this.editCompany.emit(company);
  }
  onDeleteCompany (company : Company) {
    this.deleteCompany.emit(company);
  }



}
